import React from 'react';
import { Link } from 'react-router-dom';

export default function SuperHome() {
  const Card = ({ to, title, desc }) => (
    <Link
      to={to}
      className="block rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 p-5 transition"
    >
      <div className="text-cyan-300 font-semibold">{title}</div>
      <div className="text-sm text-white/70 mt-1">{desc}</div>
    </Link>
  );

  return (
    <section>
      <h2 className="text-xl font-semibold mb-2">Welcome</h2>
      <p className="text-white/70 mb-6">
        Use the tabs above to create organizations, manage settings, access tools, and monitor founder metrics.
      </p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card to="/super/founder" title="Founder Metrics" desc="Lead funnel, active orgs, usage, and estimated MRR." />
        <Card to="/super/orgs/new" title="Create Organization" desc="Provision a new org and its admin." />
        <Card to="/super/orgs" title="Organizations" desc="Search, edit, or remove organizations." />
        <Card to="/super/tools" title="Tools" desc="Handy admin utilities." />
        <Card to="/super/download" title="Device Download" desc="Manage linked Neo devices, kill switch, and install links." />
        <Card to="/super/support" title="Support Desk" desc="Review Neo support tickets, reply, and update status." />
        <Card to="/super/ontime" title="On Time Admin" desc="Create On Time orgs and prepare owner/admin/online/store/driver access." />
        <Card to="/super/archives" title="Archives" desc="Review archived orgs, device actions, and inactive users." />
      </div>
    </section>
  );
}
